import React, { Component } from "react";
import parse from 'html-react-parser';
import {getFavoriteTopics,getFavoriteAuthor,sectionlist,opinionapi,authorslist} from '../config/Variables';
import {baseurl} from '../config/Settings';

export default class FetchUsertags extends Component {

  constructor() {
    super();
    this.state = {
      hobbies: [],
      tid: '',
      sectionslist:[],
      sectiontids: "",
      messagelog: '',
      isLoading: true,
      users: [],
      loading:true,
      sectionlabels: [],
      numberstid: [],
      error: null,
      lengthusers: 111110
    }   
    this.getFetchNewsletterpamap = this.getFetchNewsletterpamap.bind(this);
    this.getFetchUsers = this.getFetchUsers.bind(this);
    this.getFetchNewsletter = this.getFetchNewsletter.bind(this);
    console.log("lamba");
  }

 

   getFetchSectionsLabel() {

var sectionstring='';
    let user = JSON.parse(localStorage.getItem('user-info'))
         let datt = fetch(getFavoriteTopics, {
           method: 'POST',
           headers: {
             "Content-Type": "application/json",
             "Accept": 'application/json',
             "Authorization": "Bearer " + user.token.access_token,
           },
           body: JSON.stringify(this.state)
         }).then(response => response.json())
           .then(data => {
            if(data.webmsg.code==401){
              localStorage.clear();
              var domainurl=  window.location.origin;
              window.location.href = domainurl+'/journey';
            }
             data.data.map(({ tid }, index2) => {
              sectionstring =tid + '+' + sectionstring ;
              // this.state.numberstid.push(tid);
               //this.setState({ numberstid: [this.state.numberstid, tid] })
             //  this.setState({ numberstid: this.state.numberstid })
               this.state.sectionslist.push(tid);
             });
             var ss=this.state.sectionslist.join('+');
             if(ss ===""){
              ss="none";
            }
             this.setState({
              loading: true
            }, () => {
              fetch(sectionlist+ss).then(res => res.json()).then(result => this.setState({
                loading: false,
                sectionlabels: result
              })).catch(console.log);
            });
           });
           
           //var ss=this.state.sectionslist.join('+');
           
         

   }

   getFetchUsers() {
    var sectionstring='';
    let user = JSON.parse(localStorage.getItem('user-info'))
         let datt = fetch(getFavoriteAuthor, {
           method: 'POST',
           headers: {
             "Content-Type": "application/json",
             "Accept": 'application/json',
             "Authorization": "Bearer " + user.token.access_token,
           },
           body: JSON.stringify(this.state)
         }).then(response => response.json())
           .then(data => {
             data.data.map(({ tid }, index2) => {
              sectionstring =tid + '+' + sectionstring ;
              // this.state.numberstid.push(tid);
               //this.setState({ numberstid: [this.state.numberstid, tid] })
             //  this.setState({ numberstid: this.state.numberstid })
               this.state.sectionslist.push(tid);
             });
             var ss=this.state.sectionslist.join('+');
             if(ss ===""){
               ss="none";
             }
             this.setState({
              loading: true
            }, () => {
              fetch(authorslist+ss).then(res => res.json()).then(result => this.setState({
                loading: false,
                sectionlabels: result
              })).catch(console.log);
            });
           });
      }

  getFetchNewsletterpamap(event) {

    const target = event.target;
    var value = event.currentTarget.getAttribute("data-value");

    var urllink=opinionapi+value;
    
    this.setState({
        loading: true
    }, () => {
        fetch(urllink).then(res => res.json()).then(result => this.setState({
            loading: false,
            users: result,
            sectiontids: value
        })).catch(console.log);
    });
    //var scriptaudio = document.createElement('script'); scriptaudio.type = 'text/javascript'; scriptaudio.src = 'https://aawsat.com/themes/custom/aawsatv3/assets/js/custom_js.js'; document.head.appendChild(scriptaudio);
}


  getFetchNewsletter(nextProps) {
   
 
    //var urllink="https://aawsat.com/" + this.props.url;

    var urllink=baseurl + nextProps.url;
    const x=444444;
  if(this.props.parameters==null){
    x=0;
  }
    this.setState({
        loadings: true,
        lengthusers: x 
    }, () => {
        fetch(urllink).then(res => res.json()).then(result => this.setState({
            loadingss: false,
            users: result,
            sectiontids:  this.props.parameters
        })).catch(console.log);
    });
    
}
componentDidMount() {
    
    this.getFetchUsers();

    this.getFetchNewsletter(this.props);
    //this.getPosts(this.props);

}
runAfterRender = () => 
{
  const myElem = document.getElementById("myElem")
  if(myElem)
  {
    //do important stuff
  }
}

render() {
  const {
    users,
    error,
    loading,
    sectiontids,
    sectionlabels,
    lengthusers
  } = this.state;

  if(loading ==false){
    var script = document.createElement('script'); script.type = 'text/javascript'; script.src = 'https://aawsat.com/themes/custom/aawsatv3/assets/js/app.js?fessssssssssvs='; document.head.appendChild(script);
     }
 
  if(this.state.loading ==false){
    var scriptaudiofile = document.createElement('script'); scriptaudiofile.type = 'text/javascript'; scriptaudiofile.src = 'https://aawsat.com/themes/custom/aawsatv3/assets/js/modules/audio-players.gn.js?ssssssssss'; document.head.appendChild(scriptaudiofile);
  }
  if(this.state.loading ==false){
    var scriptaudio = document.createElement('script'); scriptaudio.type = 'text/javascript'; scriptaudio.src = 'https://aawsat.com/themes/custom/aawsatv3/assets-react/js/custom_js.js?ssxssssss'; document.head.appendChild(scriptaudio);
  }

  if(lengthusers ==111110){
    return(
      <>
      {loading ? <div className="loading-mypage">   <img src="https://aawsat.com/themes/custom/aawsatv3/assets-react/img/loading-new.gif?ssss"/></div>: ""}
      </>
      );
  } if(lengthusers ==0  && loading==true){
    return (
      <div class="cell small-12 large-3 c-tab-content_js" data-id="myAuthors">
    <div className="content-wrap vertical-scroll"> 
        <div className="section-wrapper">
            <div className="section-title style-v2 show-for-large">
                <h3><span><a href="#">كتابي</a></span></h3>
                <div className="more"><a href="#"><i className="icomoon-icon icon-arrow-left hide"></i></a></div>
            </div>
            <div className="section-content"> 
    <div class="category-content">
                                                   <div class="empty-content">
                                                      <div class="empty-content-img">
                                                          <img src={`${baseurl}themes/custom/aawsatv3/assets/img/icon/search.svg`} alt="search"/>
                                                      </div>
                                                      <div class="empty-content-text">
                                                          لا يوجد لديك  كتاب مفضلين
                                                      </div>
                                                      <div class="emtpty-content-button">
                                                          <button data-id="modal-author" class="modal-toggle button primary rounded">اختر كتابك المفضلين</button>
                                                      </div>
                                                   </div>
                                              </div>
                                              </div>
                                              </div>
                                              </div>
                                              </div>);
  }else{




  return (
    <div class="cell small-12 large-3 c-tab-content_js" data-id="myAuthors">
                    <div class="content-wrap vertical-scroll"> 
                        <div class="section-wrapper">
                            <div class="section-title style-v2 show-for-large">
                                <h3><span><a href="#">كتابي</a></span></h3>
                                <div class="more"><a href="#"><i class="icomoon-icon icon-arrow-left hide"></i></a></div>
                            </div>
                            <div class="section-content"> 
                                  <div class="category-menu">
                                        <div class="category-menu-add">
                                            <div class="add-more small round modal-toggle" data-id="modal-author">
                                                <i class="icomoon-icon icon-plus-green"></i>  
                                            </div>  
                                        </div>
                                          <div class="category-menu-tags">
                                                 <ul class="category-tags author-tags cat_js"> 
                                                  
                                                    <li class="all-tag">
                                                    
                                                    <button  value={this.props.parameters}  data-value={this.props.parameters} className={sectiontids==this.props.parameters ? 'button active' : 'button'} onClick={this.getFetchNewsletterpamap} > الكل</button>
                                                    </li>
                                                      <React.Fragment>
                                                        {
                                                          sectionlabels.map(({ name, tid, field_opinion_writer_photo }, index) => {
                                                        
                                                            return (
                                                            
                                                            <li class={tid==sectiontids ? 'is-active' : ''} > <button  className={tid==sectiontids ? 'author-tag  active' : ' author-tag'} data-value={tid}  onClick={this.getFetchNewsletterpamap} >
                                                            <img src={field_opinion_writer_photo} alt="author" />
                                                            <span>{name}</span> 
                                                            </button> 
                                                            </li> 
                                                            );
                                                        })            
                                                      }                                   

                                                      </React.Fragment>
                                                </ul>
                                              </div>
                                        </div>
                                        <div class="category-content">
                                            <div class="objects-list audio-podcast audio-podcast--no-bar has-separator">
                                            
                                            {loading ? <div className="cell loading-mypage"><img src="https://aawsat.com/themes/custom/aawsatv3/assets-react/img/loading-new.gif?Sds" /></div> : 
                                             
                                             <React.Fragment>
                                              {
                                               
                                                users.map(({ rendered_entity }, index) => {
                                              
                                                    return (
                                                      <div class="object-item">
                                                        {parse(rendered_entity)}
                                                        </div>
                                                    );
                                                })
                                              }
                                            </React.Fragment>   



                                           }

                                                      
                                            </div> 
                                        </div>
                                
                                
                                      </div>
                                  </div>


                              </div>
                          </div>    
                              
                         
  );
                                          }                        

}
  
}
